module.exports = __webpack_public_path__ + "img/fond_apropos.231afaab.jpg";